// src/pages/Projects.jsx
// The full Field Notes archive: selected projects in chronological progress.
//
// Mirrors the structure of the Field Notes section on Home.jsx but stands alone
// as a dedicated page with its own intro framing. Content is static; this is
// editorial curation, not data.

export default function Projects() {
  return (
    <section className="max-w-wide mx-auto px-6 py-20 md:py-28">
      {/* Page header with editorial framing */}
      <div className="mb-16">
        <p className="label-mono">Field Notes</p>
        <h1 className="font-display text-h2 leading-tight font-medium mt-3">
          Selected work
        </h1>
        <p className="text-body text-ink-70 leading-relaxed mt-6 max-w-2xl">
          Three projects, roughly in the order they appeared. One shipped, one
          in active development, one still in the design column. Filed for the
          record.
        </p>
      </div>

      {/* Project list */}
      <div className="border-t border-ink-20">
        {/* Project 1 */}
        <article className="border-b border-ink-20 py-8">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 items-baseline">
            <p className="label-mono md:col-span-2">No. 01 · 2026</p>
            <div className="md:col-span-7">
              <h2 className="font-display text-h3 font-medium leading-tight mb-2">
                <a href="#" className="hover:text-oxblood transition-colors">
                  Footnote
                </a>
              </h2>
              <p className="text-body text-ink-70 leading-relaxed">
                An epistemic infrastructure engine with a civic grounding layer,
                built to translate information awareness into local action.
              </p>
            </div>
            <div className="md:col-span-3 md:text-right">
              <p className="label-mono">In progress</p>
            </div>
          </div>
        </article>

        {/* Project 2 */}
        <article className="border-b border-ink-20 py-8">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 items-baseline">
            <p className="label-mono md:col-span-2">No. 02 · 2026</p>
            <div className="md:col-span-7">
              <h2 className="font-display text-h3 font-medium leading-tight mb-2">
                <a href="#" className="hover:text-oxblood transition-colors">
                  PostgreSQL Blog API
                </a>
              </h2>
              <p className="text-body text-ink-70 leading-relaxed">
                A Node.js / Express REST API migrated from MongoDB to PostgreSQL
                with a relational schema, parameterized queries, and clean CRUD
                on users and posts.
              </p>
            </div>
            <div className="md:col-span-3 md:text-right">
              <p className="label-mono">Shipped</p>
            </div>
          </div>
        </article>

        {/* Project 3 */}
        <article className="border-b border-ink-20 py-8">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 items-baseline">
            <p className="label-mono md:col-span-2">No. 03 · planned</p>
            <div className="md:col-span-7">
              <h2 className="font-display text-h3 font-medium leading-tight mb-2">
                <a href="#" className="hover:text-oxblood transition-colors">
                  Workshop OS
                </a>
              </h2>
              <p className="text-body text-ink-70 leading-relaxed">
                A small-batch manufacturing operations layer: CNC scheduling,
                Theory-of-Constraints capacity planning, and on-chain provenance
                for finished goods.
              </p>
            </div>
            <div className="md:col-span-3 md:text-right">
              <p className="label-mono">Concept</p>
            </div>
          </div>
        </article>
      </div>
    </section>
  );
}
